import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { ADMIN_ACCESS_TOKEN_KEY } from "@malirang/common";
import { AlertService, LocalStorageService } from "@malirang/front-share";
import { catchError, from, mergeMap, throwError } from "rxjs";

export const HttpInterceptor: HttpInterceptorFn = (req, next) => {
    const localStorageService = inject(LocalStorageService);
    const alertService = inject(AlertService);

    return from(
        (async () => {
            const accessToken = await localStorageService.get(
                ADMIN_ACCESS_TOKEN_KEY,
            );

            return req.clone({
                setHeaders: {
                    Authorization: accessToken ? `Bearer ${accessToken}` : "",
                },
            });
        })(),
    ).pipe(
        mergeMap((updatedRequest) => next(updatedRequest)),
        catchError((e) => {
            if (e.status === 497) {
                const alert = alertService.open({
                    type: "danger",
                    title: "접근 불가",
                    content: `현재 계정으로는 접근이 불가능합니다.
          자세한 사항은 관리자에게 문의해주세요.`,
                    buttons: {
                        confirm: { hidden: true },
                        cancel: { text: "확인" },
                    },
                });

                alert.closed.subscribe({
                    next: () => {
                        localStorageService.remove(ADMIN_ACCESS_TOKEN_KEY);
                        window.location.href = "/";
                    },
                });
            }

            return throwError(() => e.error);
        }),
    );
};
